// extracted by mini-css-extract-plugin
module.exports = {"shelfContainer":"Shelf_shelfContainer__Q3P--","shelfHeader":"Shelf_shelfHeader__iu5RB","resize":"Shelf_resize__2i5a4","separator":"Shelf_separator__raWuq"};